export class DeformAniData {
    constructor() {
        this.deformSlotDataList = [];
    }
}
